export default __webpack_public_path__ + "src/assets/winter-poap.40d7553f4cf6f24475320f52e2b575cc.svg";